import React, { useState } from 'react';
import {
  Button,
  FormControl,
  Grid,
  Typography,
  ButtonGroup,
  Input,
  styled,
  Alert,
  Snackbar,
  useTheme,
  // CircularProgress,
  // Backdrop,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Box,
  Modal
} from '@mui/material';
import { VscEye } from 'react-icons/vsc';
import { getImages2 } from 'API/Approval/api';
// import ImageModal from 'views/utilities/Components/Approval/Components/ImageModal';
import CloseIcon from '@mui/icons-material/Close';
import { FaImage } from 'react-icons/fa';
import { LoadingButton } from '@mui/lab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  display: 'flex',
  objectFit: 'contain',
  boxShadow: 24,
  p: 4
};
const Document = (props) => {
  const [open, setOpen] = useState(false);
  // const [OpenImage, setOpenImage] = useState(false);
  const [FileType, setFileType] = useState(null);
  // const [ImageFile, setImageFile] = useState(null);
  const [Filevalue, setFilevalue] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [FilePreviewoOpen, setFilePreviewoOpen] = useState('');
  const UserList = props.UserList;
  console.log('UserList', UserList);
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => setOpen(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [ImageType, setImageType] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };
  // const handleOpenAlert = () => {
  //   setOpenAlert(true);
  // };
  const handleClosePreview = () => {
    setPreviewOpen(false);
  };
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleImageClose = () => {
  //   setOpenImage(false);
  // };
  // const handleImageOpen = () => {
  //   setOpenImage(true);
  // };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });
  const theme = useTheme();
  const data = [
    {
      name: 'aadharcard_file',
      display_name: 'Aadhar Card',
      required: true
    },
    {
      name: 'pancard_file',
      display_name: 'Pancard Card',
      required: true
    },
    {
      name: 'marksheet_10th_12th',
      display_name: '10th / 12th Marksheet',
      required: true
    },
    {
      name: 'cir_report',
      display_name: 'CIR Report',
      required: true
    },
    {
      name: 'statement_saving',
      display_name: 'Statement / Passbook copy / Cheque - Saving',
      required: true
    },
    {
      name: 'statement_od_ca',
      display_name: 'Statement / Passbook copy / Cheque - OD/CA',
      required: true
    },
    {
      name: 'Address_proof',
      display_name: 'Address Proof',
      required: true
    },
    {
      name: 'gst_certificate',
      display_name: 'GST Certificate',
      required: true
    },
    {
      name: 'graduation_certificate',
      display_name: 'Graduation Certificate',
      required: false
    }
  ];
  console.log('Filevalue', Filevalue);

  const handleFileUpload = (fieldName, file) => {
    console.log("ff",file);

    if (file) {
      setFilePreviewoOpen(file);
      const newFileValues = { ...Filevalue, [fieldName]: file.name }; // Store file name for specific field
      setFilevalue(newFileValues);

      const updatedPostData = {
        ...props.postData,
        [fieldName]: file // Storing the actual file object (binary)
      };

      props?.handleStep(updatedPostData);
    }
  };
  const handleFileViewelse = (file) => {
    if (file) {
      console.log('im open', file);
      setPreviewOpen(true);
      setPreviewUrl(URL.createObjectURL(file));
      setFileType(file.type);
    }
  };
    const [DialogImageOpen, setDialogImageOpen] = useState(false);
    const [ImageList, setImageList] = useState([]);

  const handleFileView = (url) => {
    console.log('im open', url);
     setDialogImageOpen(true);
      setImageList(url);
  };
  // const getFileName = (url) => {
  //   return url && url?.substring(url.lastIndexOf('/') + 1);
  // };
  return (
    <>
    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 6,
                padding: '5px',
                top: 5,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
            {ImageType && ImageType === 'pdf' ? (
              <iframe src={ImageUrl} title="PDF Viewer" style={{ width: '100%', height: '500px', border: 'none' }} />
            ) : (
              <img src={ImageUrl} alt="img" style={{ width: '100%', objectFit: 'contain' }} />
            )}
          </Box>
        </Modal>
    {/* uploaded view */}
          <Dialog open={DialogImageOpen} onClose={() => setDialogImageOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle variant="h4">
              Documents
              <IconButton onClick={() => setDialogImageOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Stack spacing={2} sx={{ width: '100%', padding: 2 }}>
                <Grid container spacing={2}>
                  {ImageList.map((file, index) => {
                    return (
                      <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <LoadingButton
                          fullWidth
                          variant="outlined"
                          onClick={() => getImages2(file, setImageUrl, setImageType, handleOpen, setIsLoading)}
                          // onClick={()=>getImages(file, setImageFile, handleImageOpen, handleOpenAlert, handleOpen, handleClose, setFileType)}
                          color="secondary"
                          startIcon={<FaImage />}
                          sx={{
                            textTransform: 'none',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                          loading={isLoading}
                        >
                          <Typography noWrap sx={{ maxWidth: '100%' }}>
                            {file
                              ? (() => {
                                  // const text = file.split('-').splice(-3).join('');
                                  const text = file.split('/').pop();
                                  return text.length > 30 ? text.slice(20, text.length) : text;
                                })()
                              : ''}
                          </Typography>
                        </LoadingButton>
                      </Grid>
                    );
                  })}
                </Grid>
              </Stack>
            </DialogContent>
          </Dialog>
      {/* <ImageModal open={OpenImage} handleClose={handleImageClose} image={ImageFile} fileType={FileType} /> */}
      {/* <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <Snackbar
        open={OpenAlert}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setOpenAlert(false)}
      >
        <Alert onClose={() => setOpenAlert(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          Something went wrong
        </Alert>
      </Snackbar>
      <Typography variant="h4">KYC Documents</Typography>
      <Grid item xs={12} sm={12} xl={12}>
        <Grid container spacing={1}>
          {data &&
            data
              ?.filter((item) => Array.isArray(UserList?.[item.name]) && UserList[item.name].length > 0)
              ?.map((item, index) => {
                const fileUrl = UserList && UserList[item?.name];
                // const displayFileName = (Filevalue && Filevalue[item?.name]) || getFileName(fileUrl);

                return (
                  <Grid item xs={12} lg={6} md={6} sm={12} xl={6} key={index}>
                    <FormControl variant="standard" fullWidth sx={{ ...theme.typography.customInput }}>
                      <Typography variant="h5" mb={1}>
                        {item.display_name}
                      </Typography>
                      <Input
                        id="outlined-adornment-fname-register"
                        type="text"
                        inputProps={{
                          readOnly: 'true'
                        }}
                        value={Filevalue?.[item.name]&&Filevalue?.[item.name]}
                        name={item.name}
                        sx={{ height: '45px' }}
                        endAdornment={
                          <ButtonGroup>
                            <Button
                              component="label"
                              role={undefined}
                              sx={{
                                borderColor: '#592375',
                                color: '#592375',
                                borderRadius: '6px',
                                '&:hover': {
                                  borderColor: '#592375'
                                }
                              }}
                              variant="outlined"
                              size="small"
                              color="secondary"
                              tabIndex={-1}
                            >
                              {fileUrl ? 'Reupload' : 'Upload'}
                              <VisuallyHiddenInput
                                name={item.name}
                                onChange={(e) => handleFileUpload(item.name, e.target.files[0])}
                                type="file"
                              />
                            </Button>

                            <Button
                              size="small"
                              color="secondary"
                              sx={{
                                borderColor: '#592375',
                                color: '#592375',
                                borderRadius: '6px',
                                '&:hover': {
                                  borderColor: '#592375'
                                }
                              }}
                              onClick={() => {
                                if (Filevalue[item.name]) {
                                  console.log('else');
                                  handleFileViewelse(FilePreviewoOpen);
                                } else if (fileUrl) {
                                  console.log('if');
                                  handleFileView(fileUrl);
                                }
                              }}
                            >
                              <VscEye fontSize={'20px'} />
                            </Button>
                          </ButtonGroup>
                        }
                        // onChange={(e) => handleFileUpload(item.name, e.target.files[0])}
                      />
                    </FormControl>
                  </Grid>
                );
              })}
        </Grid>
      </Grid>
      <Grid mt={2} display={'flex'} justifyContent={'center'}>
        <Button
          color="secondary"
          variant="outlined"
          sx={{
            mr: 2,
            width: '25%',
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
          onClick={props.handleBank}
        >
          back
        </Button>
        <Button
          color="secondary"
          sx={{
            width: '25%',
            backgroundColor: '#688B2A',
            color: '#FFFFFF',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#688B2A'
            }
          }}
          variant="contained"
          onClick={props.handleNext}
        >
          update
        </Button>
      </Grid>

      <Dialog open={previewOpen} maxWidth="md" fullWidth>
        <DialogTitle>
          File Preview
          <IconButton
            aria-label="close"
            onClick={handleClosePreview}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {FileType?.includes('image') ? (
            <img src={previewUrl} alt="Preview" style={{ width: '100%', height: 'auto' }} />
          ) : FileType === 'application/pdf' ? (
            <iframe src={previewUrl} title="pdfviewer" width="100%" height="500px" />
          ) : (
            <Typography variant="body1">Unsupported file format</Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Document;
